import React from "react";
import {
  Edit,
  SimpleForm,
  SelectInput,
  // REDUX_FORM_NAME,
  required,
  NumberInput,
  SimpleFormIterator,
  ArrayInput,
  TopToolbar,
  ReferenceInput,
  RefreshButton,
  FormDataConsumer,
  SaveButton,
  Toolbar,
  DeleteButton,
  TextInput,
  DateTimeInput,
  usePermissions,
  useRecordContext,
  useRedirect,
} from "react-admin";
// import { DateTimeInput } from "react-admin-date-inputs";
// import { change } from 'redux-form';
// import { useForm } from "react-final-form";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";

import { sdoStatuses, LineItemsSideComponent } from "./common";
import { getLocalStorageKey } from "../common/common";

const EditActions = () => (
  <TopToolbar>
    <RefreshButton />
  </TopToolbar>
);

const SdoEditToolbar = (permissions) => {
  // const permissions = usePermissions();
  const record = useRecordContext();

  console.log("record EDIT ", record);
  return (
    <Toolbar className="custom-toolbar">
      <SaveButton alwaysEnable />
      {permissions === "isManual" && (
        <DeleteButton
          redirect={`/sap_digital_orders/${record.sap_digital_order_id}/show/2`}
        />
      )}
    </Toolbar>
  );
};

// const LineItemQuantityBagsField = ({ data }) =>
//     <span>{data.ordered_quantity && data.ordered_quantity * 20}</span>

const EditRedirect = (_basePath, _id, data) =>
  `sap_digital_orders/${data.sap_digital_order_id}/show/2`;

const validateSdoLineItems = (value, allValues) => {
  if (allValues?.order_status?.toString() === 15 && !value.length > 0) {
    return "Sdo Line Items are required";
  }
};

const OrderOrigin = ({ formData, permissions, ...props }) => {
  const form = useForm();
  const sdoFieldSettings = getLocalStorageKey("sdo_field_settings");
  const hideVatInput = getLocalStorageKey("hide_vat_input") || false;
  console.log(formData, props);

  return (
    <React.Fragment>
      <TextInput label="Order Number" source="order_number" />
      {/* <TextInput label="Sales Order Number" source="logon_order_no" /> */}
      {sdoFieldSettings &&
        sdoFieldSettings.shipment_number &&
        sdoFieldSettings.shipment_number.enabled && (
          <TextInput label="Shipment Number" source="shipment_number" />
        )}
      {
        sdoFieldSettings &&
          sdoFieldSettings.load_number &&
          sdoFieldSettings.load_number.enabled && (
            // <FormDataConsumer>
            //     {({ formData, dispatch }) => (
            <TextInput
              label="Loading Number"
              onChange={({ target: { value } }) => {
                if (!formData.truck_plate_no) {
                  if (formData.delivery_plant_no) {
                    if (value) {
                      form.setValue("order_status", "8");
                      // form.change(REDUX_FORM_NAME, 'order_status', "8");
                    } else {
                      form.setValue("order_status", "5");
                    }
                  }
                }
              }}
              source="load_number"
            />
          )
        //     )
        //     }
        // </FormDataConsumer>
      }
      {/* <FormDataConsumer>
        {({ formData, dispatch, ...rest }) => (
          <ReferenceInput
            className="plant-select-input"
            onChange={(value) => {
              console.log("plant-value", value);
              console.log("dispatch", dispatch);
              if (!formData.truck_plate_no) {
                if (formData.load_number) {
                  if (value[0]) {
                    form.change(REDUX_FORM_NAME, "order_status", "8");
                  } else {
                    form.change(REDUX_FORM_NAME, "order_status", "5");
                  }
                }
              }
            }}
            filter={{ business_id: formData.sap_digital_order.business_id }}
            source="delivery_plant_no"
            reference="sap_plants"
            label="Plant"
            allowEmpty
            {...rest}
          >
            <SelectInput
              FormHelperTextProps={{ classes: { root: "hide-helper" } }}
              optionText="name"
              optionValue="plant_code"
            />
          </ReferenceInput>
        )}
      </FormDataConsumer> */}
      <SelectInput
        source="order_status"
        onChange={(value) => console.log("status-value", value)}
        choices={sdoStatuses}
      />
      <FormDataConsumer>
        {({ formData, dispatch }) => (
          <TextInput
            source="truck_plate_no"
            onChange={({ target: { value } }) => {
              if (value) {
                form.setValue("order_status", "15");
                // form.change(REDUX_FORM_NAME, "order_status", "15");
              } else if (formData.load_number && formData.delivery_plant_no) {
                form.setValue("order_status", "8");
                // form.change(REDUX_FORM_NAME, "order_status", "8");
              } else {
                form.setValue("order_status", "5");
                // form.change(REDUX_FORM_NAME, "order_status", "5");
              }
            }}
          />
        )}
      </FormDataConsumer>
      <TextInput label="Delivery Note" source="lsd_order_no" />
      <FormDataConsumer>
        {({ formData, ...rest }) =>
          formData?.order_status?.toString() >= 11 && (
            <DateTimeInput
              source="loading_date"
              label="Loading Date"
              options={{ format: "d/M/y h:mm a", ampm: true, clearable: true }}
            />
          )
        }
      </FormDataConsumer>
      <FormDataConsumer>
        {({ formData, ...rest }) => (
          <ArrayInput
            validate={validateSdoLineItems}
            label="SDO line items"
            source="sap_materials_for_sdo"
            className="add-remove-cont"
          >
            <SimpleFormIterator className="add-remove">
              <FormDataConsumer>
                {({ formData, getSource }) => {
                  const lineItems = [];
                  formData.digital_order_line_items &&
                    formData.digital_order_line_items.forEach((product) => {
                      lineItems.push({
                        id: product.product_master.id,
                        name: product.product_master.description,
                      });
                    });
                  return (
                    <SelectInput
                      source={getSource("product_master.id")}
                      label="Product Name"
                      choices={lineItems}
                      validate={required()}
                    />
                  );
                }}
              </FormDataConsumer>
              <FormDataConsumer>
                {({ formData, scopedFormData, getSource }) => {
                  console.log(
                    "scopedFormData - scopedFormData",
                    scopedFormData
                  );

                  const prod =
                    formData.digital_order_line_items &&
                    formData.digital_order_line_items.filter(
                      (li) =>
                        li.product_master.id ===
                        (scopedFormData &&
                          scopedFormData.product_master &&
                          scopedFormData.product_master.id)
                    )[0];
                  if (prod) scopedFormData.product_master = prod.product_master;
                  return (
                    scopedFormData &&
                    scopedFormData.product_master && (
                      <NumberInput
                        source={getSource("ordered_quantity")}
                        label={`Quantity ${
                          scopedFormData.product_master.input_uom_name
                            ? `(${scopedFormData.product_master.input_uom_name})`
                            : ""
                        }`}
                        validate={required()}
                      />
                    )
                  );
                }}
              </FormDataConsumer>
              <FormDataConsumer>
                {({ scopedFormData, getSource }) =>
                  scopedFormData &&
                  scopedFormData.product_master &&
                  scopedFormData.product_master.show_conversion ? (
                    <TextInput
                      disabled
                      source={getSource("ordered_quantity")}
                      format={(v) =>
                        (v &&
                          v *
                            (scopedFormData.product_master.conversion_factor ||
                              1)) ||
                        ""
                      }
                      label={`Quantity ${
                        scopedFormData.product_master.conversion_uom_name
                          ? `(${scopedFormData.product_master.conversion_uom_name})`
                          : ""
                      }`}
                    />
                  ) : null
                }
              </FormDataConsumer>
              {/* <FormDataConsumer>
                                    {({ scopedFormData }) => <LineItemQuantityBagsField label="Quantity (Bags)" data={scopedFormData} />}
                                </FormDataConsumer> */}
              {/* <NumberInput source="netValue" label="Total Price" /> */}
              {/* {
                                    !hideVatInput &&
                                    <NumberInput source="vat_percentage" label="VAT (%)" />
                                } */}
            </SimpleFormIterator>
          </ArrayInput>
        )}
      </FormDataConsumer>
    </React.Fragment>
  );
};

const SingleDeliveryOrdersEdit = ({ ...props }) => {
  const form = useForm();
  const hideVatInput = getLocalStorageKey("hide_vat_input") || false;
  const sdoFieldSettings = getLocalStorageKey("sdo_field_settings");
  const location = useLocation();
  const permissions = usePermissions();
  const redirect = useRedirect();
  const lineItems =
    location.state &&
    location.state.order &&
    location.state.order.digital_order_line_items;

  return (
    <Edit
      title="Edit SDO"
      redirect={EditRedirect}
      aside={
        <LineItemsSideComponent
          digital_order={{ digital_order_line_items: lineItems }}
        />
      }
      undoable={false}
      actions={<EditActions permissions={permissions} />}
      {...props}
    >
      <SimpleForm
        // redirect={EditRedirect}
        className="half-grid"
        toolbar={<SdoEditToolbar permissions={permissions} />}
      >
        <FormDataConsumer>
          {(formDataProps) => <OrderOrigin {...formDataProps} data={props} />}
        </FormDataConsumer>
      </SimpleForm>
    </Edit>
  );
};

export default SingleDeliveryOrdersEdit;
